import { apiClient } from "../lib/api-client";
import { User, Project, ExportRequest, ApiResponse } from "../types/api.types";

export interface AdminStats {
    totalUsers: number;
    totalProjects: number;
    totalExports: number;
    activeSubscriptions: number;
}

export const adminService = {
    async getStats(): Promise<AdminStats> {
        const response = await apiClient.get<AdminStats>("/admin/stats");
        if (response.success && response.data) {
            return response.data;
        }
        throw new Error(response.message || "Failed to fetch admin stats");
    },

    async getUsers(): Promise<User[]> {
        const response = await apiClient.get<User[]>("/admin/users");
        if (response.success && response.data) {
            return response.data;
        }
        throw new Error(response.message || "Failed to fetch users");
    },

    async deleteUser(userId: string): Promise<void> {
        const response = await apiClient.delete<any>(`/admin/users/${userId}`);
        if (!response.success) {
            throw new Error(response.message || "Failed to delete user");
        }
    },

    async toggleUserStatus(userId: string): Promise<User> {
        const response = await apiClient.patch<User>(`/admin/users/${userId}/status`, {});
        if (response.success && response.data) {
            return response.data;
        }
        throw new Error(response.message || "Failed to toggle user status");
    },

    async getUserActivity(userId: string): Promise<any> {
        const response = await apiClient.get<any>(`/admin/users/${userId}/activity`);
        if (response.success && response.data) {
            return response.data;
        }
        throw new Error(response.message || "Failed to fetch user activity");
    },

    async extendTrial(userId: string, trialEndsAt: string): Promise<User> {
        const response = await apiClient.patch<User>(`/admin/users/${userId}/trial`, { trialEndsAt });
        if (response.success && response.data) {
            return response.data;
        }
        throw new Error(response.message || "Failed to extend trial");
    },

    async updateUserRole(userId: string, role: 'user' | 'admin'): Promise<User> {
        const response = await apiClient.patch<User>(`/admin/users/${userId}/role`, { role });
        if (response.success && response.data) {
            return response.data;
        }
        throw new Error(response.message || "Failed to update user role");
    }
};
